module.exports = __webpack_public_path__ + "img/bank-submit-h.ca5f6b78.png";